export default __webpack_public_path__ + "static/media/ic_alert_humidity.959400c6.svg";